'use client'

import { scan } from 'react-scan'
// eslint-disable-next-line perfectionist/sort-imports
import { useEffect } from 'react'
// eslint-disable-next-line perfectionist/sort-imports
import type { JSX } from 'react'

export function ReactScan(): JSX.Element {
  useEffect(() => {
    scan({
      enabled: process.env.NODE_ENV === 'development',
    })
  }, [])

  return <></>
}
